import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-changjiananli",
  "use": "icon-changjiananli-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-changjiananli\"><path fill=\"#BFCBD9\" d=\"M960.512 428.032V83.968H565.248V0H198.656L63.488 102.4v327.68H0v454.656C0 960.512 63.488 1024 141.312 1024h741.376c77.824 0 141.312-63.488 141.312-139.264V428.032h-63.488z m-151.552-266.24h73.728v266.24h-73.728v-266.24z m-133.12 0h75.776v266.24H675.84v-266.24z m-129.024 0h73.728v266.24h-73.728v-266.24zM139.264 122.88h79.872V55.296h270.336v372.736H139.264V122.88z m743.424 833.536H141.312c-40.96 0-73.728-32.768-73.728-71.68v-389.12h890.88v387.072c-2.048 40.96-34.816 73.728-75.776 73.728z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/changjiananli.svg
// module id = eUcA
// module chunks = 26